export type SkillCategory = "profession" | "lead" | "language" | "tools";

// Color mapping for skill categories - using more visible/contrasted colors
export const SKILL_CATEGORY_COLORS = {
  profession: "bg-blue-600 text-white border-blue-700", // More visible blue
  lead: "bg-purple-600 text-white border-purple-700", // More visible purple
  language: "bg-indigo-600 text-white border-indigo-700", // More visible indigo
  tools: "bg-gray-600 text-white border-gray-700", // More visible gray
} as const;

// Dark mode colors - adjusted for better visibility in dark theme
export const SKILL_CATEGORY_COLORS_DARK = {
  profession: "bg-blue-500 text-white border-blue-400", // Brighter blue for dark mode
  lead: "bg-purple-500 text-white border-purple-400", // Brighter purple for dark mode
  language: "bg-indigo-500 text-white border-indigo-400", // Brighter indigo for dark mode
  tools: "bg-gray-500 text-white border-gray-400", // Brighter gray for dark mode
} as const;
